module.exports = __webpack_public_path__ + "img/version.5c5b5b67.png";